import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { GeneralExaminationModel } from '../models/GeneralExaminationModel';
import { URLsConfig } from '../URLsConfig';

@Injectable()
export class GeneralExaminationService {
    constructor(private http: HttpClient, public urlsconfig: URLsConfig) {
    }
    public getGExamination(patientCode: string , comCode: string) {
      let params = new HttpParams();
        params = params.append("patientCode", patientCode);
        params = params.append("compCode", comCode);
        const options = {
            params: params
        };
        return this.http.get<GeneralExaminationModel>(this.urlsconfig.WebAPIURL_Test + 'api/GeneralExamination/GetGeneralExamination',options);
    }
    public AddGExamination(Gexamination: GeneralExaminationModel) {

        return this.http.post<GeneralExaminationModel>(this.urlsconfig.WebAPIURL_Test + 'api/GeneralExamination/AddGeneralExamination', Gexamination);
    }
    public delGExamination(patientCode: string , compCode: string) {

      let params = new HttpParams();
        params = params.append("patientCode", patientCode);
        params = params.append("compCode", compCode);
        const options = {
          params: params
      };
      return this.http.get<GeneralExaminationModel>(this.urlsconfig.WebAPIURL_Test + 'api/GeneralExamination/DeleteGeneralExamination',options);
    }


   
}
